module.exports = __webpack_public_path__ + "img/DCHQ-small-dark.6b5732a3.svg";